import { render, staticRenderFns } from "./InvoiceStatusForm.vue?vue&type=template&id=3b251ca7&scoped=true"
import script from "./InvoiceStatusForm.vue?vue&type=script&lang=js"
export * from "./InvoiceStatusForm.vue?vue&type=script&lang=js"
import style0 from "./InvoiceStatusForm.vue?vue&type=style&index=0&id=3b251ca7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b251ca7",
  null
  
)

export default component.exports